import pagefra from "./pagefra.vue";

const self = {
    install: function(Vue) {
        Vue.component("pagefra", pagefra);
    }
};

export default self;